import {FC} from "react";

interface UploadSummaryProps {
    event: string
    number_of_days: string
}
const UploadSummaryRow: FC<UploadSummaryProps> = (props) => {

    const {event, number_of_days} : {event:string, number_of_days: string} = props;
    return (
        <tr>
            <td>
                <div className="align-items-center">
                    <p className="fs-12 text-muted my-0">
                        {event}
                    </p>
                </div>
            </td>
            <td>
                <div className="align-items-center">
                    <p className="mb-0 fw-semibold my-0">{number_of_days}</p>
                </div>
            </td>
        </tr>
    );
};

export default UploadSummaryRow;
